module.exports = __webpack_public_path__ + "assets/img/patient-man-icon.3f747be0.png";